import React, { FC, useLayoutEffect, useRef } from 'react'

interface SocialIconsProps {
  color: 'black' | 'white'
}

export const SocialIcons: FC<SocialIconsProps> = ({ color }) => {
  const commentRef = useRef(null)
  const color1 = color === 'black' ? '#08162B' : '#ffffff'
  const color2 = color === 'black' ? '#ffffff' : '#08162B'

  // https://github.com/Zneider/react-html-comment
  useLayoutEffect(() => {
    const el = commentRef?.current
    const parent= el && (el as HTMLElement).parentNode
    
    if (!el || !parent) {
      return
    }

    (parent as HTMLElement).replaceChild(document.createComment('https://www.svgrepo.com/svg/138936/linkedin'), el)
  })

  return (
    <div className="flex items-center justify-between sm:max-w-xs">
      <a
        href="https://www.facebook.com/Agora-Pay-107453057652899/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 29.9824 7.31367 38.2566 16.875 39.757V25.7813H11.7969V20H16.875V15.5938C16.875 10.5813 19.8609 7.8125 24.4293 7.8125C26.6176 7.8125 28.9062 8.20313 28.9062 8.20313V13.125H26.3844C23.9 13.125 23.125 14.6668 23.125 16.2484V20H28.6719L27.7852 25.7813H23.125V39.757C32.6863 38.2566 40 29.9824 40 20Z"
            fill={color1}
          />
          <path
            d="M27.7852 25.7812L28.6719 20H23.125V16.2484C23.125 14.6668 23.9 13.125 26.3844 13.125H28.9062V8.20312C28.9062 8.20312 26.6176 7.8125 24.4293 7.8125C19.8609 7.8125 16.875 10.5813 16.875 15.5938V20H11.7969V25.7812H16.875V39.757C17.8934 39.9168 18.9367 40 20 40C21.0633 40 22.1066 39.9168 23.125 39.757V25.7812H27.7852Z"
            fill={color2}
          />
        </svg>
      </a>

      <a
        href="https://www.instagram.com/agorapay/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.9996 3.86445C25.2551 3.86445 25.877 3.88477 27.9527 3.9793C29.8715 4.0668 30.9137 4.38711 31.6074 4.65664C32.5262 5.01367 33.1816 5.44023 33.8707 6.12851C34.5598 6.81758 34.9863 7.47305 35.3426 8.3918C35.6121 9.08555 35.9324 10.1277 36.0199 12.0465C36.1145 14.1215 36.1348 14.7441 36.1348 19.9996C36.1348 25.2551 36.1145 25.877 36.0199 27.9527C35.9324 29.8715 35.6121 30.9137 35.3426 31.6074C34.9855 32.5262 34.559 33.1816 33.8707 33.8707C33.1816 34.5598 32.5262 34.9863 31.6074 35.3426C30.9137 35.6121 29.8715 35.9324 27.9527 36.0199C25.8777 36.1145 25.2551 36.1348 19.9996 36.1348C14.7441 36.1348 14.1215 36.1145 12.0465 36.0199C10.1277 35.9324 9.08555 35.6121 8.3918 35.3426C7.47305 34.9855 6.81758 34.559 6.12852 33.8707C5.43945 33.1816 5.01289 32.5262 4.65664 31.6074C4.38711 30.9137 4.0668 29.8715 3.9793 27.9527C3.88477 25.8777 3.86445 25.2551 3.86445 19.9996C3.86445 14.7441 3.88477 14.1223 3.9793 12.0465C4.0668 10.1277 4.38711 9.08555 4.65664 8.3918C5.01367 7.47305 5.44023 6.81758 6.12852 6.12851C6.81758 5.43945 7.47305 5.01289 8.3918 4.65664C9.08555 4.38711 10.1277 4.0668 12.0465 3.9793C14.1223 3.88477 14.7441 3.86445 19.9996 3.86445ZM19.9996 0.318359C14.6543 0.318359 13.984 0.341016 11.8848 0.437109C9.79023 0.532422 8.35898 0.865234 7.10742 1.35195C5.81289 1.85508 4.71523 2.52773 3.62148 3.62227C2.52773 4.71602 1.8543 5.81367 1.35117 7.10742C0.864453 8.35898 0.531641 9.79023 0.436328 11.8848C0.341016 13.984 0.318359 14.6543 0.318359 19.9996C0.318359 25.3449 0.341016 26.0152 0.437109 28.1145C0.532422 30.209 0.865234 31.6402 1.35195 32.8918C1.85508 34.1863 2.52773 35.284 3.62227 36.3777C4.7168 37.4723 5.81367 38.1449 7.1082 38.648C8.35977 39.1348 9.79102 39.4676 11.8855 39.5629C13.9848 39.659 14.6551 39.6816 20.0004 39.6816C25.3457 39.6816 26.016 39.659 28.1152 39.5629C30.2098 39.4676 31.641 39.1348 32.8926 38.648C34.1871 38.1449 35.2848 37.4723 36.3785 36.3777C37.473 35.2832 38.1457 34.1863 38.6488 32.8918C39.1355 31.6402 39.4684 30.209 39.5637 28.1145C39.6598 26.0152 39.6824 25.3449 39.6824 19.9996C39.6824 14.6543 39.6598 13.984 39.5637 11.8848C39.4684 9.79023 39.1355 8.35898 38.6488 7.10742C38.1457 5.81289 37.473 4.71523 36.3785 3.62148C35.284 2.52695 34.1871 1.8543 32.8926 1.35117C31.641 0.864453 30.2098 0.531641 28.1152 0.436328C26.0152 0.341016 25.3449 0.318359 19.9996 0.318359Z"
            fill={color1}
          />
          <path
            d="M19.9988 9.89355C14.4168 9.89355 9.89258 14.4186 9.89258 19.9998C9.89258 25.5811 14.4168 30.1061 19.9988 30.1061C25.5809 30.1061 30.1051 25.5818 30.1051 19.9998C30.1051 14.4178 25.5809 9.89355 19.9988 9.89355ZM19.9988 26.56C16.3754 26.56 13.4387 23.6225 13.4387 19.9998C13.4387 16.3771 16.3762 13.4396 19.9988 13.4396C23.6223 13.4396 26.559 16.3771 26.559 19.9998C26.559 23.6225 23.6223 26.56 19.9988 26.56Z"
            fill={color1}
          />
          <path
            d="M30.5063 11.8553C31.8106 11.8553 32.868 10.7979 32.868 9.49356C32.868 8.18921 31.8106 7.13184 30.5063 7.13184C29.2019 7.13184 28.1445 8.18921 28.1445 9.49356C28.1445 10.7979 29.2019 11.8553 30.5063 11.8553Z"
            fill={color1}
          />
        </svg>
      </a>

      <a href="https://www.linkedin.com/company/agora-pay" target="_blank" rel="noopener noreferrer">
        <span ref={commentRef} className="hidden" />
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 112.196 112.196">
          <circle cx="56.098" cy="56.097" r="56.098" fill="#FFFFFF"/>
          <path fill="#08162B" d="M89.616 60.611v23.128H76.207V62.161c0-5.418-1.936-9.118-6.791-9.118-3.705 0-5.906 2.491-6.878 4.903-.353.862-.444 2.059-.444 3.268v22.524h-13.41s.18-36.546 0-40.329h13.411v5.715c-.027.045-.065.089-.089.132h.089v-.132c1.782-2.742 4.96-6.662 12.085-6.662 8.822 0 15.436 5.764 15.436 18.149zm-54.96-36.642c-4.587 0-7.588 3.011-7.588 6.967 0 3.872 2.914 6.97 7.412 6.97h.087c4.677 0 7.585-3.098 7.585-6.97-.089-3.956-2.908-6.967-7.496-6.967zm-6.791 59.77H41.27v-40.33H27.865v40.33z" />
        </svg>
      </a>
    </div>
  )
}
